import { render, staticRenderFns } from "./LaboratoryTrackingView.vue?vue&type=template&id=acab94ce&scoped=true&"
import script from "./LaboratoryTrackingView.vue?vue&type=script&lang=js&"
export * from "./LaboratoryTrackingView.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryTrackingView.vue?vue&type=style&index=0&id=acab94ce&scoped=true&lang=css&"
import style1 from "./LaboratoryTrackingView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acab94ce",
  null
  
)

export default component.exports